// assets
import {
  Dashboard,
  Business,
  Room,
  PersonAdd,
  ExitToApp,
  BookOnline,
  Bed,
  Description
} from '@mui/icons-material';

const isPatientOnly = (roles = []) => roles.length === 1 && roles[0].toLowerCase() === 'patient';


// ==============================|| MENU ITEMS - IPD ||============================== //

const ipd = {
  id: 'ipd',
  title: 'IPD Management',
  type: 'group',
  visible: (roles) => !isPatientOnly(roles),
  children: [
    {
      id: 'ipd-dashboard',
      title: 'IPD Dashboard',
      type: 'item',
      url: '/ipd',
      icon: Dashboard,
      breadcrumbs: false,
      matchEnd: true,
      visible: (roles) => !isPatientOnly(roles)
    },
    {
      id: 'patient-admission',
      title: 'Patient Admission',
      type: 'item',
      url: '/ipd/admission',
      icon: PersonAdd,
      breadcrumbs: false,
      visible: (roles, isAdmin) => isAdmin || roles.includes('lab_billing') || roles.includes('doctor')
    },
    {
      id: 'discharge-management',
      title: 'Patient Management',
      type: 'item',
      url: '/ipd/discharge',
      icon: ExitToApp,
      breadcrumbs: false,
      visible: (roles, isAdmin) => isAdmin || roles.includes('doctor') || roles.includes('lab_billing') || roles.includes('account_manager') || roles.includes('pharmacy_biller')
    },
    {
      id: 'ipd-print-forms',
      title: 'Print Forms',
      type: 'item',
      url: '/ipd/print-forms',
      icon: Description,
      breadcrumbs: false,
      visible: (roles) => !isPatientOnly(roles)
    },
    {
      id: 'bed-management',
      title: 'Bed Management',
      type: 'item',
      url: '/ipd/beds',
      icon: Bed,
      breadcrumbs: false,
      visible: (roles, isAdmin) => isAdmin || roles.includes('lab_billing') || roles.includes('doctor') || roles.includes('nurse') || roles.includes('receptionist')
    },
    {
      id: 'bed-reservation',
      title: 'Bed Reservation',
      type: 'item',
      url: '/ipd/reservations',
      icon: BookOnline,
      breadcrumbs: false,
      visible: (roles, isAdmin) => isAdmin || roles.includes('lab_billing') || roles.includes('doctor') || roles.includes('receptionist')
    },
    {
      id: 'floor-management',
      title: 'Floor Management',
      type: 'item',
      url: '/ipd/floors',
      icon: Business,
      breadcrumbs: false,
      visible: (roles, isAdmin) => isAdmin || roles.includes('lab_billing')
    },
    {
      id: 'room-management',
      title: 'Room Management',
      type: 'item',
      url: '/ipd/rooms',
      icon: Room,
      breadcrumbs: false,
      visible: (roles, isAdmin) => isAdmin || roles.includes('lab_billing')
    }
  ]
};

export default ipd;